import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { BatchSummaryInformation } from '../types'

type MassPayoutConfirmationSummaryProps = {
  batchInformation: BatchSummaryInformation
}

export const MassPayoutConfirmationSummary = ({
  batchInformation,
}: MassPayoutConfirmationSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Box paddingX={16}>
      {batchInformation?.numberOfPayments && (
        <DataListItem
          id="number-of-payments"
          testId="number-of-payments"
          title={t('massPayouts.numberOfPayments')}
          body={batchInformation?.numberOfPayments}
        />
      )}
      {batchInformation?.totalBatchAmount && (
        <DataListItem
          id="total-batch-amount"
          testId="total-batch-amount"
          title={t('massPayouts.batchAmount')}
          body={batchInformation?.totalBatchAmount}
        />
      )}
      {batchInformation?.totalBatchFees && (
        <DataListItem
          id="total-batch-fees"
          testId="total-batch-fees"
          title={t('massPayouts.fees')}
          body={batchInformation?.totalBatchFees}
        />
      )}
      {batchInformation?.totalBatchAmountWithFees && (
        <DataListItem
          id="total-batch-amount-with-fees"
          testId="total-batch-amount-with-fees"
          title={t('massPayouts.batchAmountInclFees')}
          body={batchInformation?.totalBatchAmountWithFees}
        />
      )}
      {batchInformation?.walletName && (
        <DataListItem
          id="wallet-name"
          testId="wallet-name"
          title={t('massPayouts.payingFromWallet')}
          body={`${batchInformation?.walletName} (${batchInformation.currency})`}
        />
      )}
    </Box>
  )
}
